<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PtoJ1c/tc-custom/9783988267856.jpg?1704425610719" alt="This image is the cover for the book Uncle Wiggily's Funny Auto, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle Wiggily's Funny Auto, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Uncle Wiggily's Auto Sled is a children's book written by Howard Roger Garis. It is part of the Uncle Wiggily series, which follows the adventures of a friendly elderly rabbit named Uncle Wiggily. In this book, Uncle Wiggily gets a new auto sled and decides to take a trip to the South Pole with his animal friends, including Sammy and Susie Littletail, the two rabbit children he often helps. Along the way, they have many exciting adventures and meet new friends, including the polar bears and Eskimos. However, they also encounter some challenges, such as a dangerous ice bridge that they must cross. The book is filled with fun and whimsical illustrations and teaches valuable lessons about friendship, courage, and perseverance. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Roger Garis
      </h2>
      
      <p class="authorDescription body article">Howard Roger Garis (April 25, 1873 – November 6, 1962) was an American author, best known for a series of books that featured the character of Uncle Wiggily Longears, an engaging elderly rabbit. Many of his books were illustrated by Lansing Campbell. Garis and his wife, Lilian Garis, were possibly the most prolific children's authors of the early 20th century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e4eddd6